import React, { useState } from 'react';
import { projects } from '../data/portfolio';
import './Projects.css';

const statusLabels = {
  published: 'Published',
  'in-development': 'In Development',
};

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [filter, setFilter] = useState('all');

  const filteredProjects = projects.filter(project => {
    if (filter === 'all') return true;
    if (filter === 'featured') return project.featured;
    return project.status === filter;
  });

  const openModal = (project) => {
    setSelectedProject(project);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedProject(null);
    document.body.style.overflow = '';
  };

  if (selectedProject) {
    return (
      <div className="project-modal-overlay" onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="project-modal-title">
        <div className="project-modal" onClick={(e) => e.stopPropagation()}>
          <button className="project-modal__close" onClick={closeModal} aria-label="Close project details">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <div className="project-modal__content">
            <div className="project-modal__header">
              <h2 id="project-modal-title" className="project-modal__title">{selectedProject.title}</h2>
              <span className="badge badge--info">{statusLabels[selectedProject.status] || selectedProject.status}</span>
            </div>
            <p className="project-modal__description">{selectedProject.longDescription}</p>

            <div className="project-modal__tech">
              <h3 className="project-modal__tech-title">Tech Stack</h3>
              <div className="project-modal__tech-list">
                {selectedProject.techStack.map((tech, index) => <span key={index} className="badge">{tech}</span>)}
              </div>
            </div>

            <div className="project-modal__features">
              <h3 className="project-modal__features-title">Key Features</h3>
              <ul className="project-modal__features-list">
                {selectedProject.features.map((feature, index) => (
                  <li key={index} className="project-modal__feature-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className="project-modal__links">
              {selectedProject.links.github && (
                <a href={selectedProject.links.github} className="btn btn--outline" target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
                  </svg>
                  GitHub
                </a>
              )}
              {selectedProject.links.appStore && (
                <a href={selectedProject.links.appStore} className="btn btn--secondary" target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
                  </svg>
                  App Store
                </a>
              )}
              {selectedProject.links.playStore && (
                <a href={selectedProject.links.playStore} className="btn btn--primary" target="_blank" rel="noopener noreferrer">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                  Play Store
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <section id="projects" className="projects section" aria-labelledby="projects-title">
      <div className="container">
        <header className="section-header" data-eyebrow="Projects">
          <h2 id="projects-title" className="section-title">Featured Projects</h2>
          <p className="section-subtitle">Mobile applications I've built and shipped to production</p>
        </header>

        <div className="projects__filters" role="tablist" aria-label="Filter projects">
          {['all', 'featured', 'published'].map((f) => (
            <button
              key={f} role="tab" aria-selected={filter === f}
              className={`projects__filter-btn ${filter === f ? 'projects__filter-btn--active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'all' ? 'All Projects' : f === 'featured' ? 'Featured' : 'Published'}
            </button>
          ))}
        </div>

        <div className="projects__grid">
          {filteredProjects.map((project) => (
            <article
              key={project.id} className="project-card" onClick={() => openModal(project)}
              tabIndex={0} onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && openModal(project)}
              role="button" aria-label={`View ${project.title} project details`}
            >
              <div className="project-card__image">
                <div className="project-card__image-placeholder" aria-hidden="true">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" />
                  </svg>
                </div>
                {project.featured && <span className="project-card__featured-badge">Featured</span>}
                <span className={`project-card__status project-card__status--${project.status}`}>
                  {statusLabels[project.status] || project.status}
                </span>
              </div>
              <div className="project-card__content">
                <h3 className="project-card__title">{project.title}</h3>
                <p className="project-card__description">{project.description}</p>
                <div className="project-card__tech">
                  {project.techStack.slice(0, 4).map((tech, index) => <span key={index} className="badge badge--tech">{tech}</span>)}
                  {project.techStack.length > 4 && (
                    <span className="badge badge--tech badge--more">+{project.techStack.length - 4}</span>
                  )}
                </div>
                <div className="project-card__footer">
                  <span className="project-card__year">{project.year}</span>
                  <span className="project-card__cta">
                    View Details
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
